import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	jobs: {
		"& a": {
			alignItems: "center",
			color: "#FFFFFF",
			display: "flex",
			fontSize: 14,
			gap: theme.spacing(1),
			textTransform: "uppercase",
			"& svg path": {
				fill: "rgba(255,255,255,0.5)",
				fillOpacity: 1
			},
			"&:hover": {
				"& svg path": {
					fill: "rgba(255,255,255,1)"
				}
			}
		}
	},
	count: {
		alignItems: "center",
		background: "#e20074",
		borderRadius: "50%",
		color: "#FFFFFF",
		display: "flex",
		fontSize: 12,
		justifyContent: "center",
		height: 24,
		lineHeight: 1,
		width: 24
	}
}));

export default styles;
